import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const SubscriptionEnforcementModal = ({ show, onClose, vendorData }) => {
  const navigate = useNavigate();

  // Calculate days since account creation
  const calculateDaysActive = () => {
    if (!vendorData || !vendorData.createdAt) return 0;
    const createdAt = new Date(vendorData.createdAt);
    const today = new Date();
    return Math.floor((today - createdAt) / (1000 * 60 * 60 * 24));
  };

  const daysActive = calculateDaysActive();
  const hasSubscription = vendorData?.subscription?.status === 'ACTIVE';

  const handleSubscribe = () => {
    navigate('/vendor/subscription');
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Subscription Required</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-4">
          <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: '48px' }}></i>
        </div>
        <p>Your account has been active on Weedhurry for <strong>{daysActive} days</strong>.</p>
        <p>To continue operating on our marketplace and maintain visibility to customers, an active subscription is required after the 60-day trial period.</p>
        
        {daysActive > 60 && !hasSubscription && (
          <div className="alert alert-danger">
            <strong>Your account access has been limited.</strong> You need to subscribe to restore full access to the platform and remain visible to customers.
          </div>
        )}
        
        {daysActive <= 60 && !hasSubscription && (
          <div className="alert alert-warning">
            <strong>Your free trial ends in {60 - daysActive} days.</strong> Please subscribe before your trial period ends to maintain uninterrupted service.
          </div>
        )}
        
        <hr />
        <p className="text-muted">
          Subscribing gives you access to all platform features and ensures your business remains visible to potential customers in our marketplace.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Remind Me Later
        </Button>
        <Button variant="primary" onClick={handleSubscribe}>
          Subscribe Now
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubscriptionEnforcementModal;